import { ReactNode } from 'react'
import { IconSizes } from 'types/general'

import IconRender from './IconRender'

interface ButtonProps {
  children: ReactNode
  onClick: () => void
  onMouseEnter?: (e: React.MouseEvent<HTMLButtonElement>) => void
  onMouseLeave?: (e: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  isLoading?: boolean
  padding?: string
  margin?: string
  border?: string
  borderHover?: string
  textColor?: string
  textHoverColor?: string
  bgColor?: string
  bgHoverColor?: string
  font?: string
  loadingStyle?: string
  customStyle?: string
}

const Button = ({
  children,
  onClick,
  onMouseEnter,
  onMouseLeave,
  disabled = false,
  isLoading = false,
  textColor,
  customStyle,
}: ButtonProps) => {
  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      disabled={disabled || isLoading}
      className={`relative m-0 px-5 py-2.5 rounded-lg font-semibold text-base transition-all duration-200 ${
        disabled || isLoading
          ? 'cursor-not-allowed bg-imovPrimary/35 text-white'
          : 'bg-imovPrimary text-white shadow-md hover:bg-imovPrimaryDark hover:shadow-lg active:translate-y-px active:shadow-sm'
      } ${customStyle ?? ''}`}
    >
      {isLoading ? (
        <span className="absolute inset-0 flex items-center justify-center">
          <IconRender
            icon="regular-spinner-third"
            size={IconSizes.LG}
            color={textColor}
            className="animate-spin bg-none"
          />
        </span>
      ) : null}
      <span className={isLoading ? 'opacity-0' : undefined}>{children}</span>
    </button>
  )
}

export default Button
